/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x7e0d=['shift','compress','push','types'];(function(_0x4b0721,_0x7e0dae){var _0x5a3c62=function(_0x2a387e){while(--_0x2a387e){_0x4b0721['push'](_0x4b0721['shift']());}};_0x5a3c62(++_0x7e0dae);}(_0x7e0d,0x77));var _0x5a3c=function(_0x4b0721,_0x7e0dae){_0x4b0721=_0x4b0721-0x0;var _0x5a3c62=_0x7e0d[_0x4b0721];return _0x5a3c62;};import _0x46fb3b from'./operationcompressor';export default class f extends _0x46fb3b{[_0x5a3c('0x2')](_0x1fa894,_0x5f0ec8){_0x5f0ec8[_0x5a3c('0x1')](),_0x1fa894[_0x5a3c('0x0')][_0x5a3c('0x3')](this['id']);}['decompress'](_0xe23fb2,_0x1645e5){_0x1645e5[_0x5a3c('0x0')][_0x5a3c('0x1')](),_0xe23fb2['push']({'__className':this['operationName']});}}